import React,{ useEffect, useState } from 'react';
import { Avatar, Drawer, Popover} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronRight, faClose, faGear, faGhost, faInfo, faInfoCircle,  } from '@fortawesome/free-solid-svg-icons';
import relativeTime from 'dayjs/plugin/relativeTime';
import "@src/components/notification/notification.css";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { manageNotificationSeenMutation } from '../../util/mutation/notification.mutation';
import { socket } from '../../config/socket';
import { useSelector } from 'react-redux';
import { getNotificationMeta } from '@src/util/notificationMeta';
import { routes } from '@src/util/routes/routes';

dayjs.extend(relativeTime);
dayjs.extend(utc);

function displayRelativeTime(date) {
    const now = dayjs();
    const pastDate = dayjs(date);
    return pastDate.from(now); // Returns a human-readable relative time string
}

  
export const NotificationPage = () => {

    const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);   
    const [notificationData, setNotificationData] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
            const employeeId = authenticatedUserDetail?.employeeDetail?.[0]?._id?.toString() || localStorage.getItem('employeeId');

            setLoading(true);

            const handleNotificationEvent = (event) => {
                if (event?.type === 'patch' && event.op === 'insert' && event.record) {
                    setNotificationData(prev => [event.record, ...prev]);
                } else if (event?.type === 'init') {
                    setNotificationData(event.response || []);
                }
                setLoading(false);
            };

            const emitSubscribe = () => {
                socket.emit("subscribe", {
                    action: 'subscribe',
                    module: 'notification',
                    param: {
                        userId: authenticatedUserDetail?._id,
                        employeeId,
                        limit: 50000,
                        tenantId: authenticatedUserDetail?.tenantId || localStorage.getItem('tenantId'),
                    },
                });
            };

            socket.on("notification", handleNotificationEvent);
            if (socket.connected) emitSubscribe();
            socket.on('connect', emitSubscribe);

            return () => {
                socket.off('notification', handleNotificationEvent);
                socket.off('connect', emitSubscribe);
            };
    }, [authenticatedUserDetail?.employeeDetail]);

    const [notificationList, setNotificationList] = useState([]);



    const convertToDate = (key) => {
          // Split the key and convert it to a date object
          const [day, month, year] = key.split("/");
          return new Date(`${year}-${month}-${day}`); // Convert to Date object (YYYY-MM-DD format)
    };
  
    useEffect(()=>{
        if(notificationData?.length>0){

            const readyData= notificationData?.map((notification)=>{
                return {
                    ...notification,
                    link: notification?.entityType.toLowerCase().includes('employee') && notification?.notificationType?.toLowerCase().includes('skill')?
                    "/user/employee-detail/"+notification?.entityId+"/tab/skills"
                    : notification?.entityType.toLowerCase().includes('employee') && notification?.notificationType?.toLowerCase().includes('visa')?
                    "/user/employee-detail/"+notification?.entityId+"/tab/hr"
                    : notification?.entityType.toLowerCase().includes('employee') && notification?.notificationType?.toLowerCase().includes('follow')?
                    "/user/employee-detail/"+notification?.entityId
                    : ['PendingEmployees', 'VerifyEmployeeChanges'].includes(notification?.entityType)?
                    `?tab=${notification?.entityType === 'VerifyEmployeeChanges' ? 'changes' : 'new'}${routes.pendingEmployees}` : null
                }
            });

            const groupedData = readyData.reduce((acc, item) => {
                // Get the date from the current item
                const date = dayjs(item.createdAt).format("DD/MM/YYYY") == dayjs().format("DD/MM/YYYY")? "Today" :  dayjs(item.createdAt).format("DD/MM/YYYY");
                
                // If the date doesn't exist in the accumulator, create a new array for it
                if (!acc[date]) {
                    acc[date] = [];
                }
                
                // Push the current item to the group for its date
                acc[date].push(item);
                
                // Return the accumulator for the next iteration
                return acc;
            }, {});


            const today = groupedData['Today'];
            delete groupedData['Today'];

            const sortedKeys = Object.keys(groupedData).sort((a, b) => convertToDate(b) - convertToDate(a));
            const sortedData = {};
            sortedKeys.forEach((key) => {
              sortedData[key] = groupedData[key];
            });
            

            setNotificationList({Today:today, ...sortedData});            

        }
          
    },[notificationData]);

    const navigate = useNavigate();

    const [manageNotificationSeen] = useMutation(manageNotificationSeenMutation);

    const handelNotificationSeen = async (id)=>{
        await manageNotificationSeen({
            variables:{
                manageNotificationSeenId: id
            }
        });
    }

  return (
    <div >


            <div className='n-header cursor'>
                All Notifications 
                {/* <FontAwesomeIcon icon={faArrowRight} /> */}
            </div>
                       
            <div className="n-body" style={{background: '#F5F8FA', padding:'0 20px'}}>
                {
                    notificationList?.length==0?
                    <div className="nn-body" style={{margin:0, display:'flex', flexDirection:'column', alignItems:'center', gap:'10px', justifyContent:'center', height:'100vh'}}>
                        <FontAwesomeIcon icon={faGhost} style={{fontSize:'130px', color:'#516f90'}}/>
                        <div className='n-mainText'>You don't have any notifications</div>
                        <div className='n-subText'>But as soon as something happens, you'll find it right here.</div>
                    </div>
                    : 
                    loading?
                    <div className="nn-body" style={{margin:0, display:'flex', flexDirection:'column', alignItems:'center', gap:'10px', justifyContent:'center', height:'100vh'}}>
                        <FontAwesomeIcon icon={faInfoCircle} style={{fontSize:'130px', color:'#516f90'}}/>
                        <div className='n-mainText'>Loading your notifications...</div>
                        <div className='n-subText'>Please wait a moment.</div>
                    </div>
                    :
                        Object.keys(notificationList)?.map((notification)=>{
                            if(notificationList[notification]?.length>0){
                                return(
                                    <div style={{width:'50%', background:'white', margin:'auto'}}>
                                        <div className='notification-day'>
                                            {notification}
                                        </div>
                                        {
                                            notificationList[notification]?.map((noti)=>{
                                                const meta = getNotificationMeta(noti?.notificationType);
                                                return(
                                                    <div className="notificationList" onClick={()=>{navigate(noti?.link); handelNotificationSeen(noti?._id)}}>
                                                        <div className='user-avatar'>
                                                            <Avatar size={"large"} style={{background: meta.bg, color: meta.color}}>
                                                                <FontAwesomeIcon icon={meta.icon} />
                                                            </Avatar>
                                                        </div>
                                                        <div style={{width:'70%'}}>
                                                            <div className="notification-category" style={{color: meta.color}}>{meta.label}</div>
                                                            <div className="notification-title">{noti?.title}</div>
                                                            <div className="notification-description">{noti?.description}</div>

                                                        </div>
                                                        <div style={{display:'flex', gap:'4px', width:'145px', alignItems: 'center', height:'fit-content', justifyContent:'end'}}>
                                                            {noti?.seen? "" :<div style={{width:'10px', height:'10px', background:'#0091ae', borderRadius:'50%'}}></div>}
                                                            <div style={{fontWeight:'400'}}>{displayRelativeTime((noti?.createdAt))}</div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }
                        })
                    

                    
                }
            </div>


    </div>
    );
}